
const initialState = {
    list_users: null,
    loading_list_users: false,
    error_list_users: null,
    loading_edit_new_user: false,
    message_edit_new_user: null
};

export default function usuario(state=initialState, action){
    switch (action.type){
        case 'USERS_LOADING':
            return { list_users: null, loading_list_users: true, error_list_users: null};
        case 'USERS_LOAD_SUCCESS':
            return {...state, list_users: action.data, loading_list_users: false, error_list_users: null};
        case 'USERS_LOAD_FAILED':
            return {...state, list_users: null, loading_list_users: false, error_list_users: action.data};
        case 'SEND_USER_LOADING':
            return {...state, loading_edit_new_user: true, message_edit_new_user: null};
        case 'SEND_USER_SUCCESS':
            return {...state, loading_edit_new_user: false, message_edit_new_user: action.data};
        case 'SEND_USER_FAILED':
            return {...state, loading_edit_new_user: false, message_edit_new_user: action.data};
        default:
            return state;

    }
}